import React, { useState } from "react";
import "./FAQ.css";
import AccordionItem from "./../../components/AccordionItem";

const FAQ = () => {
  const [activeSection, setActiveSection] = useState("What is Diamond?");

  const toggleSection = (title) => {
    setActiveSection((prev) => (prev === title ? null : title));
  };

  return (
    <div className="faq1-container">
      <h1 className="faq1-title">FAQ</h1>
      <div className="faq1-content">
        {faqData.map((section) => (
          <AccordionItem
            key={section.title}
            title={section.title}
            content={section.content}
            isActive={activeSection === section.title}
            onToggle={() => toggleSection(section.title)}
          />
        ))}
      </div>
    </div>
  );
};

export default FAQ;

const faqData = [
  {
    title: "Payment Queries",
    content: (
      <div>
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">
              Are your prices negotiable? Do you accept offers?
            </p>
            <p className="paragraphxyz">We deal only in one price.</p>
            <p className="headingxyz">Do you give terms?</p>
            <p className="paragraphxyz">
              We always deal in advance payment or COD.
            </p>
            <p className="headingxyz">Do we accept credit card?</p>
            <p className="paragraphxyz">
              NO, We do not accept credit card however you can use other modes
              of payment.
            </p>
            <p className="headingxyz">
              What do you mean by "One Price Policy"?
            </p>
            <p className="paragraphxyz">
              The prices of our products are determined following a watchful
              study of the market conditions with a view to ensure a fair deal
              for the customer. The prices are obviously fixed, eliminating the
              need to bargain and consequently saving the precious time of the
              customer.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Shipping",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">
              Can you ship the stone to address other than our normal shipping
              address?
            </p>
            <p className="paragraphxyz">
              Yes. As per your advice we can send at your responsibility.
            </p>
            <p className="headingxyz">
              Is it required that if I buy a stone today than it has to be
              shipped separately or can you combine our buying & send all the
              stones in one parcel?
            </p>
            <p className="paragraphxyz">
              We can surely help you to combine the shipment so you save on
              shipping charges. For this you must pay for each purchase within a
              day or two.
            </p>
            <p className="headingxyz">
              Which shipping company you normally use?
            </p>
            <p className="paragraphxyz">
              We use Malca Amit, Brinks, BVC, Lemiure, G4S, Dunbar for all our
              shipments.
            </p>
            <p className="headingxyz">Do you use FedEx or UPS?</p>
            <p className="paragraphxyz">
              We can also send thorough FedEx or UPS on special request but it's
              at your own risk.
            </p>
            <p className="headingxyz">The shipment sent by you is insured?</p>
            <p className="paragraphxyz">
              Yes. Shipments sent through Malca Amit, Brinks, Dunbar, G4S, BVC,
              Lemiure are insured door to door. Shipments sent through any
              airlines are insured till your airport till you or your agent
              collects it.
            </p>
            <p className="headingxyz">
              Do we have to pay any shipping charges?
            </p>
            <p className="paragraphxyz">
              Yes, for shipping charges click here.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Website",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">
              I am unable to view updates and changes?
            </p>
            <p className="paragraphxyz">
              We would request you to clear cookies and cache in your browser.
              You can do that by going to tools - Internet options. In case the
              problem exists please check with your system administrator.
            </p>
            <p className="headingxyz">
              I am unable to search a diamond of my choice?
            </p>
            <p className="paragraphxyz">
              You can search the diamond of your choice by using our stock
              search. In case you can't find it, please place your demands on
              WishList or feel free to call our sales team.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Order Policy",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">
              Can we have immediate access to your inventory after we register
              online?
            </p>
            <p className="paragraphxyz">
              Once you register, we would request you to send in your
              requirements upon which we will send you the inventory file and
              after few transactions you may get access for inventory.
            </p>
            <p className="headingxyz">
              Can you help us to get the stone certified by any lab?
            </p>
            <p className="paragraphxyz">
              Yes. We can provide this service after you remit the funds for the
              stone including certification and handling charges.
            </p>
            <p className="headingxyz">
              Can we cancel the purchase or return the stone if in case we don't
              like?
            </p>
            <p className="paragraphxyz">
              Sorry, stone once confirmed cannot be cancelled.
            </p>
            <p className="headingxyz">
              Can you send us image of stones to see the shape/ matching
              pair/inclusion & also help us to understand inclusion pattern of
              the stone?
            </p>
            <p className="paragraphxyz">
              We can send you images as you need. We will be happy to assist you
              to describe the stone so you can buy the right stone as per your
              requirement.
            </p>
            <p className="headingxyz">What are your grading standards?</p>
            <p className="paragraphxyz">
              We have developed our own PI grading based on international
              standards of GIA. Apart from the normal 4c's our in-depth details
              will help you to understand & visualize the stone almost 100%. For
              more information on PI Grading system click here.
            </p>
            <p className="headingxyz">
              Do you accept bulk orders or programmes?
            </p>
            <p className="paragraphxyz">
              Yes, we accept bulk order & work on programmes also.
            </p>
          </div>
        </div>
      </div>
    ),
  },
];
